import { render, staticRenderFns } from "./Sub.vue?vue&type=template&id=255ea1b3&scoped=true&"
import script from "./Sub.vue?vue&type=script&lang=js&"
export * from "./Sub.vue?vue&type=script&lang=js&"
import style0 from "./Sub.vue?vue&type=style&index=0&id=255ea1b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255ea1b3",
  null
  
)

export default component.exports